import { GLS_WETAG_CONFIG, type GlsTagName } from './config';

/**
 * All available GLS wetag names.
 * Currently only includes the workspace tag.
 */
export type GlsTags = GlsTagName;

/**
 * The workspace tag name - use this constant instead of string literals
 * to ensure type safety and easy refactoring.
 */
export const WORKSPACE_TAG = GLS_WETAG_CONFIG.TAG_NAME;
